import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  handleError(error: any) {
    const reportableError = getReportableError(error);
    if (reportableError) {
      super.handleError(error);
      this.reportToInstana(reportableError);
    } else {
      // tslint:disable-next-line:no-console
      console.warn('😡 Non-fatal error', error);
    }
  }

  reportToInstana(error: any): void {
    // report to Instana, if available
    const _window = window as { ineum?: (any, reportableError) => void };
    if (_window && _window.ineum) {
      _window.ineum('reportError', error);
    }
  }
}

/**
 * Given an error, return the error if it should be reported, or
 * return null if the error should not be reported.
 *
 * @param  {any} error An error
 * @return {any}       An error - if it should be reported - or null
 */
function getReportableError(error: any): any | null {
  if (error && error.rejection) {
    const rejectionError = getReportableError(error.rejection);
    return rejectionError ? error : null;
  } else if (error instanceof HttpErrorResponse) {
    switch (error.status) {
      case 401:
      case 403:
      case 404: {
        return null;
      }
      default: {
        return error;
      }
    }
  }
  return error;
}
